export default __webpack_public_path__ + "static/time-tracking-fe6b3856ee5202ad4ac08a5f25f2d78f.mp4";